import { Provider } from '@angular/core';
import { CANVAS_FACTORY_BROWSER_PROVIDERS } from './canvas-factory-browser.service';
import { IMAGE_LOADER_BROWSER_PROVIDERS } from './image-loader-browser.service';

export function provideMapToolsForBrowser(): Provider[] {
  return [CANVAS_FACTORY_BROWSER_PROVIDERS, IMAGE_LOADER_BROWSER_PROVIDERS];
}
